module.exports = __webpack_public_path__ + "static/social_ner-3c5c1ff40cef5da4f7c50d221ac6b60b.jpg";